import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@circle-react/contexts";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { Typography } from "@circle-react-uikit/Typography";
import { CheckoutFormSection } from "../CheckoutFormSection";
import { CheckoutFormAccountDetails } from "./CheckoutFormAccountDetails";
import { CheckoutFormEmailVerification } from "./CheckoutFormEmailVerification";

export const CheckoutFormAccountInfo = () => {
  const { currentUser } = usePaywallCheckoutContext();
  const { isLoading: isCommunityLoading } = usePunditUserContext();

  if (isCommunityLoading) return null;

  return (
    <div className="flex flex-col gap-y-4 lg:pb-6">
      <div>
        <Typography.TitleSm weight="semibold">
          {t("paywall_checkout.your_account")}
        </Typography.TitleSm>
      </div>

      <CheckoutFormSection className="gap-y-5 !py-0">
        {currentUser ? (
          <CheckoutFormAccountDetails />
        ) : (
          <CheckoutFormEmailVerification />
        )}
      </CheckoutFormSection>
    </div>
  );
};
